import React, { useEffect, useState } from "react";
import { GetArticle } from "../../api/ArticleApi/Article";
import { useLocation, useNavigate } from "react-router-dom";
import "./ViewArticle.css";
import _default from "dompurify";

export default function ViewfinalResponse() {
  const navigate = useNavigate();
  const location = useLocation();
  const articleId = location.state?.articleId;
  // const returnPath = location.state?.returnPath || "/";

  const [finalResponse, setFinalResponse] = useState([]);
  const [success, setSuccess] = useState(true);

  useEffect(() => {
    if (articleId) {
      fetchArticleById(articleId);
    }
  }, [articleId]);

  const fetchArticleById = async (id) => {
    try {
      const response = await GetArticle({ articleId: id });

      if (response.result === 1) {
        setFinalResponse(response.result_value);
      } else {
        setSuccess(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      setSuccess(false);
    }
  };

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };
  return (
    <>
      <div className="role-box">
        <ul className="breadcumb">
          <li className="active" onClick={handleBack}>
            <i className="bi bi-file-earmark-richtext"></i>
            Article
          </li>

          <li className="dash-arrow">/</li>

          <li>
            <span>View Article</span>
          </li>
        </ul>
      </div>

      <div
        className="main_widget p-20"
        style={{
          height: "auto",
          minHeight: "fit-content",
        }}
      >
        <div className="main_widget_body article_preview_widget">
          {success ? (
            <div className="article_post_main_headin_txt">
              <div className="article_heading">
                <h1>{finalResponse.article_title}</h1>
              </div>
              <p className="post_des">{finalResponse.article_description}</p>
              <div className="article_post_preview_cover_img">
                <img
                  src={
                    finalResponse.article_coverImage ||
                    require("../../assets/images/about_banner.jpg")
                  }
                  alt="Images"
                />
              </div>

              <div className="article_post_publish_details">
                <span>{finalResponse.author_name}</span>
                <span>
                  Date :{" "}
                  {new Date(finalResponse.created_at).toLocaleDateString()}
                </span>
              </div>

              <div
                className="article_post_content"
                dangerouslySetInnerHTML={{
                  __html: _default.sanitize(finalResponse.article_content),
                }}
              ></div>
            </div>
          ) : (
            <p>Something went wrong.</p>
          )}
        </div>
      </div>
    </>
  );
}
